import { WebsitePreviewData } from './ibranson-preview.iface'

export const IBRANSON_PREVIEW_STORAGE_KEY = 'ibranson-preview'

export function saveIbransonPreview(data: WebsitePreviewData): void {
  localStorage.setItem(IBRANSON_PREVIEW_STORAGE_KEY, JSON.stringify(data))
}

export function loadIbransonPreview(): WebsitePreviewData | null {
  try {
    const raw = localStorage.getItem(IBRANSON_PREVIEW_STORAGE_KEY)
    return raw ? (JSON.parse(raw) as WebsitePreviewData) : null
  } catch {
    return null
  }
}

export function openIbransonPreview(data: WebsitePreviewData): void {
  saveIbransonPreview(data)
  const base = window.location.href.split('#')[0]
  window.open(`${base}#/preview/ibranson`, '_blank', 'noopener')
}
